/* eslint-disable no-unused-vars */
import { getFirestore, doc, getDoc, query, collection, where, getDocs } from "firebase/firestore";
import { app } from "../config"

const db = getFirestore(app);

const getUserDetails = async (documentId) => {
  try {
    const userDocRef = doc(db, "users", documentId)

    // Get the current user document
    const userDocSnap = await getDoc(userDocRef);
    console.log("userDocSnap exists:", userDocSnap.exists())
    if (userDocSnap.exists()) {
      const userData = userDocSnap.data();

      return userData;
      // const userEmail = userData.email
      // const stripeConnected = userData.stripeConnected;
      // const stripeUserId = userData.stripeUserId;

      // const signedInAs = userData.signedInAs;

      // let collectionName = "";
      // if (signedInAs == "EO") {
      //   collectionName = "EO_BusinessProfiles";
      // } else if (signedInAs == "MPS") {
      //   collectionName = "MPS_BusinessProfiles";
      // } else {
      //   console.error("Invalid user type.");
      //   return "Error: Invalid user type.";
      // }

      // // Query the respective collection for documents where userID matches documentId
      // const profileQuery = query(
      //   collection(db, collectionName),
      //   where("userId", "==", documentId)
      // );
      // const querySnapshot = await getDocs(profileQuery);
      // console.log(documentId)
      // if (!querySnapshot.empty) {
      //   const profileData = querySnapshot.docs[0].data(); // Assuming there's one profile per user

      //   const combinedData = { ...profileData, userEmail, stripeConnected, stripeUserId }

      //   return combinedData;
      // } else {
      //   console.error(`No ${signedInAs} business profile found.`);
      //   return `Error: No ${signedInAs} business profile found.`;
      // }
    } else {
      console.error("No user document found for given ID.");
      return "Error: No user document found.";
    }
  } catch (error) {
    console.error("Error fetching user details:", error);
    return `Error: ${error.message}`;
  }
};

export { getUserDetails };
